





















































import Vue from 'vue'
import UserListModal from './UserListModal.vue'
import roleStoreService, { RoleInfo } from './role-list.store'

import { finalize } from 'rxjs/operators'

import roleUserStoreService, { RoleUserInfo } from './role-user-list.store'

export default Vue.extend({
  name: '',
  components: {
    UserListModal,
  },
  filters: {},
  data() {
    return {
      userListModalVisible: false,
      role: {} as RoleInfo,
      userList: [] as RoleUserInfo[],
    }
  },
  methods: {
    createUser() {
      this.userListModalVisible = true
    },
    handlerOk($event: any) {
      const selectedUserIdList: string[] = $event.userIdList

      const hasSelectedUserList: string[] = this.userList.map(c => c.id as string)

      const newSelectedUserIdList = selectedUserIdList.filter(item => !hasSelectedUserList.some(ele => ele === item))

      if (newSelectedUserIdList.length === 0) {
        this.userListModalVisible = false
        return
      }

      this.userListModalVisible = false
      roleUserStoreService.saveRoleUser(this.role.id as string, newSelectedUserIdList).subscribe((res: any) => {
        this.$message.success(this.$t('page_role_management_add_user_succeeded'))
        this.findRoleUserList()
      })
    },
    findRoleUserList() {
      roleUserStoreService.findRolerUserList(this.role.id as string).subscribe(res => {
        this.userList = res
      })
    },
    removeUser(userId: string) {
      roleUserStoreService.removeRoleUser(this.role.id as string, userId).subscribe(res => {
        this.$message.success(this.$t('page_role_management_user_removed_successfully'))
        this.findRoleUserList()
      })
    },
  },
  created() {
    roleStoreService.selectedRole$.subscribe(role => {
      if (role.id === undefined) {
        return
      }
      this.role = role
      this.findRoleUserList()
    })
  },
  destroyed() {},
})
